export { default } from "./Hero.js";
